import { create } from 'zustand';
import type { SearchFilters, SearchFacets } from '@/types';

interface SearchState {
  filters: SearchFilters;
  facets: SearchFacets | null;
  searchHistory: string[];
  setFilters: (filters: Partial<SearchFilters>) => void;
  resetFilters: () => void;
  setFacets: (facets: SearchFacets) => void;
  addToHistory: (query: string) => void;
  clearHistory: () => void;
}

const defaultFilters: SearchFilters = {
  query: '',
  location: '',
  page: 1,
  pageSize: 20,
};

export const useSearchStore = create<SearchState>((set) => ({
  filters: { ...defaultFilters },
  facets: null,
  searchHistory: JSON.parse(localStorage.getItem('bp-search-history') || '[]'),

  setFilters: (partial) =>
    set((state) => ({
      filters: { ...state.filters, ...partial, page: partial.page ?? 1 },
    })),

  resetFilters: () => set({ filters: { ...defaultFilters } }),

  setFacets: (facets) => set({ facets }),

  addToHistory: (query) =>
    set((state) => {
      const trimmed = query.trim();
      if (!trimmed) return state;
      const history = [trimmed, ...state.searchHistory.filter((q) => q !== trimmed)].slice(0, 20);
      localStorage.setItem('bp-search-history', JSON.stringify(history));
      return { searchHistory: history };
    }),

  clearHistory: () => {
    localStorage.removeItem('bp-search-history');
    set({ searchHistory: [] });
  },
}));
